import updateDonationHeaderCTA from './donation-links';

const GRAVITY_FORMS_TRACKING_NAME = 'gravityFormsTrackingId';

function gravityForms() {
  $(document).ready(() => {
    // Announce validation success.
    if (!jQuery('.gform_confirmation_wrapper').length) {
      return;
    }

    $('html, body').animate(
      {
        scrollTop: $('.gform_confirmation_wrapper').offset().top - 500,
      },
      500,
    );
  });

  jQuery(document).on('gform_post_render', () => {
    $('body').on(
      'DOMNodeInserted',
      '.collapsible-sections-collapsible-body',
      () => {
        // Collapsible

        $('.collapsible-sections-collapsible-body:not(:last-child)').each(
          function () {
            const elem = $(this);
            if (elem.find('.btn-collapse-next').length === 0) {
              elem.append(
                '<li class="gfield"><button class="btn btn-primary btn-arrow-right btn-collapse-next" type="button">Next step</button></li>',
              );
              elem.find('.btn-collapse-next').on('click', () => {
                elem.next().trigger('click');
              });
            }
          },
        );

        // Apply to volunteer with dogs form
        function enable_collapsible_step(elem) {
          elem
            .parents('.collapsible-sections-collapsible-body')
            .find('.btn-collapse-next')
            .removeClass('disabled')
            .prop('disabled', false);

          elem
            .parents('.collapsible-sections-collapsible-body')
            .next()
            .removeClass('disabled')
            .prop('disabled', false)
            .on('click');
        }

        function disable_collapsible_step(elem) {
          elem
            .parents('.collapsible-sections-collapsible-body')
            .find('.btn-collapse-next')
            .addClass('disabled')
            .prop('disabled', true);
        }

        const gform_1 = $('#gform_1');

        gform_1
          .find('.collapsible-sections-collapsible-body')
          .each(function () {
            const elem = $(this);
            elem
              .find('.btn-collapse-next')
              .addClass('disabled')
              .prop('disabled', true);
          });

        gform_1
          .find('#collapsible-section_1_0 .gfield_contains_required input')
          .change(function () {
            const input__val = $(
              '#collapsible-section_1_0 .gfield_contains_required input[value="Yes"]:checked',
            ).length;
            const inputs = $(
              '#collapsible-section_1_0 .gfield_contains_required input[value="Yes"]',
            ).length;
            if (inputs === input__val) {
              enable_collapsible_step($(this));
            } else {
              disable_collapsible_step($(this));
            }
          });

        gform_1.find('#collapsible-section_1_1 input').change(function () {
          if (
            gform_1.find('#collapsible-section_1_1 #input_1_9 input:checked')
              .length > 0
          ) {
            enable_collapsible_step($(this));
          } else {
            disable_collapsible_step($(this));
          }
        });

        gform_1
          .find('#collapsible-section_1_2')
          .find('input, textarea')
          .change(function () {
            enable_collapsible_step($(this));
            if (
              ($('input[name="input_17"]:checked').val() === 'Yes' &&
                $('#input_1_59').val().length > 0) ||
              $('input[name="input_17"]:checked').val() === 'No'
            ) {
              enable_collapsible_step($(this));
            } else {
              disable_collapsible_step($(this));
            }
          });

        gform_1.find('#collapsible-section_1_3 input').change(function () {
          if (
            $('#input_1_39').val().length > 0 &&
            $('#input_1_40').val().length > 0
          ) {
            enable_collapsible_step($(this));
          } else {
            disable_collapsible_step($(this));
          }
        });

        // new volunteer with dog form ID 50

        const gform_50 = $('#gform_50');

        gform_50
          .find('.collapsible-sections-collapsible-body')
          .each(function () {
            const elem = $(this);
            elem
              .find('.btn-collapse-next')
              .addClass('disabled')
              .prop('disabled', true);
          });

        gform_50.find('#collapsible-section_50_0 input').change(function () {
          if (
            gform_50.find('#collapsible-section_50_0 #input_50_9 input:checked')
              .length > 0
          ) {
            enable_collapsible_step($(this));
          } else {
            disable_collapsible_step($(this));
          }
        });

        gform_50
          .find('#collapsible-section_50_1')
          .find('select, input, textarea')
          .change(function () {
            enable_collapsible_step($(this));
            if (
              ($('input[name="input_17"]:checked').val() === 'Yes' &&
                $('#input_50_59').val().length > 0) ||
              $('input[name="input_17"]:checked').val() === 'No'
            ) {
              enable_collapsible_step($(this));
            } else {
              disable_collapsible_step($(this));
            }
          });

        gform_50.find('#collapsible-section_50_2 input').change(function () {
          if (
            $('#input_50_39').val().length > 0 &&
            $('#input_50_40').val().length > 0
          ) {
            enable_collapsible_step($(this));
          } else {
            disable_collapsible_step($(this));
          }
        });
      },
    );

    // Tracking
    const eventTrackingId = $('[name=custom-event-id]').val();
    const isAjax = $('[name=gform_ajax]').length;
    const $form = $('.gform_wrapper');

    if (!eventTrackingId) {
      return;
    }

    if (isAjax) {
      document.gravityFormsTracking = eventTrackingId;
    } else {
      $form.on('submit', () => {
        window.localStorage.setItem(
          GRAVITY_FORMS_TRACKING_NAME,
          eventTrackingId,
        );
      });
    }
  });
}

function gfTracking() {
  window.addEventListener('DOMContentLoaded', () => {
    const trackingCookie = window.localStorage.getItem(
      GRAVITY_FORMS_TRACKING_NAME,
    );

    // For non-AJAX submission
    if (trackingCookie) {
      dataLayer.push({ event: trackingCookie });
      window.localStorage.removeItem(GRAVITY_FORMS_TRACKING_NAME);
    }

    // AJAX
    $(document).on('gform_confirmation_loaded', () => {
      if (document.gravityFormsTracking) {
        dataLayer.push({ event: document.gravityFormsTracking });
      }
    });
  });
}

/**
 * Expects the classes 'qld-dollar-handles' and 'qld-dollar-handles--one-off' and
 * 'qld-dollar-handles--monthly' to be set on the Radio button set for the dollar handles.
 *
 * Add the 'qld-dollar-handles--puppy-pals' class to the 'one-off' list of radio buttons
 * to use the icons/labels on the Puppy Pals application form.
 */
function QLDDollarHandlers() {
  const setIcon = (el, icon, label) => {
    const $el = $(el);
    const originalContent = $el.html();
    const labelMarkup = label ? `<small>${label}</small>` : '';

    $el.addClass(['animated-icon-parent', `animated-icon-parent--${icon}`]);

    $el.html(`<i
        class="c-icon gd-radio__icon radio__icon radio__icon--large"
        aria-hidden="true"
        data-js-animated-icon="${icon}"
        data-js-animated-icon-hover></i>
        <span>${originalContent}</span>
        ${labelMarkup}`);

    $(window).trigger('lottie.animate', $el.find('i').get(0));
  };

  $(document).on('gform_post_render', () => {
    const $dollarHandles = $('.qld-dollar-handles');
    const isPuppyPalsVariant = $dollarHandles.hasClass(
      'qld-dollar-handles--puppy-pals',
    );

    // If the dollar handles aren't on the page, do nothing.
    if (!$dollarHandles.length) return;

    const $dollarHandlesOneOff = $(
      '.qld-dollar-handles--one-off .gfield_radio > li',
    );
    const $dollarHandlesMonthly = $(
      '.qld-dollar-handles--monthly .gfield_radio > li',
    );

    // Set correct icon for each individual value based on their order.
    if ($dollarHandlesOneOff.length) {
      if (isPuppyPalsVariant) {
        setIcon(
          $($dollarHandlesOneOff.get(0)).find('label'),
          'puppy-raising',
          'Puppy development',
        );
        setIcon(
          $($dollarHandlesOneOff.get(1)).find('label'),
          'play-kit',
          'Puppy enrichment equipment',
        );
        setIcon(
          $($dollarHandlesOneOff.get(2)).find('label'),
          'one-year-vaccinations',
          'Puppy training',
        );
        setIcon(
          $($dollarHandlesOneOff.get(3)).find('label'),
          'training',
          'Guide Dog training',
        );
      } else {
        setIcon(
          $($dollarHandlesOneOff.get(0)).find('label'),
          'play-kit',
          'Puppy play kit',
        );
        setIcon(
          $($dollarHandlesOneOff.get(1)).find('label'),
          'cane',
          'White cane',
        );
        setIcon(
          $($dollarHandlesOneOff.get(2)).find('label'),
          'training',
          'Guide Dog Harness',
        );
        setIcon(
          $($dollarHandlesOneOff.get(3)).find('label'),
          'vaccinations',
          'Veterinary care',
        );
      }
    }
    if ($dollarHandlesMonthly.length) {
      if (isPuppyPalsVariant) {
        setIcon(
          $($dollarHandlesMonthly.get(0)).find('label'),
          'vaccinations',
          'Veterinary care',
        );
        setIcon(
          $($dollarHandlesMonthly.get(1)).find('label'),
          'training',
          'Puppy development program',
        );
      } else {
        setIcon(
          $($dollarHandlesMonthly.get(0)).find('label'),
          'puppy-raising',
          'Puppy development',
        );
        setIcon(
          $($dollarHandlesMonthly.get(1)).find('label'),
          'play-kit',
          'Dog enrichment equipment',
        );
        setIcon(
          $($dollarHandlesMonthly.get(2)).find('label'),
          'training',
          'Orientation & mobility',
        );
        setIcon(
          $($dollarHandlesMonthly.get(3)).find('label'),
          'one-year-vaccinations',
          'Guide Dog training',
        );
      }
    }
  });
}

function QLDDonationLink() {
  jQuery(document).on('gform_post_render', () => {
    const $form = $('.gd-donation-form');
    const $next = $('input[value="Continue"]', '#gform_page_2_1');

    if ($form.length > 0 && $next.length > 0) {
      updateDonationHeaderCTA($form, $next, 'gf_2', true);
    }
  });
}

/**
 * Set cookies to help with goal tracking
 *
 * @param {string} form The name of the form passed to submitHandler
 * @param {string} amount The donation value
 * @param {string} frequency The donation frequncy
 * @returns {undefined}
 */
export function setCookie(form, amount, frequency) {
  // Only set cookie if all values are present
  if (form) {
    document.cookie = `campaign=${form};path=/`;
  }
  if (amount && frequency) {
    document.cookie = `campaign-amount=${amount};path=/`;
    document.cookie = `campaign-frequency=${frequency};path=/`;
    document.cookie = `campaign-source=${window.location.href};path=/`;
  }
}

function QLDDonationTracking() {
  const $form = $('.gform-donate_wrapper');

  if ($form.length > 0) {
    $form.on('submit', () => {
      const $donationType = $('input[value="One-off"]').is(':checked')
        ? 'One-off'
        : 'Monthly';
      const $donationAmount = $('.ginput_total').next().val();
      const $formId = $form.attr('id');
      const $formName =
        $formId === 'gform_wrapper_2' ? 'Donation Form' : $formId;

      setCookie($formName, $donationAmount, $donationType);
    });
    // });
  }
}

export function init() {
  gravityForms();
  gfTracking();
  QLDDollarHandlers();
  QLDDonationLink();
  QLDDonationTracking();
}
